import { FeedItemsViewDto, FeedDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum FeedTypingListUpdatedTypes {
  FEED_TYPING_LIST_UPDATED = '[Chat] Feed Typing List Updated',
}
export enum JoinRoomTypes {
  JOIN_ROOM = '[Base] Join Room',
  ROOM_JOINED = '[Base] Room Joined',
  ROOM_JOIN_FAILED = '[Base] Room Join Failed',
}

export enum FeedItemUpdatedTypes {
  FEED_ITEM_UPDATED = '[Feed] Feed Item Updated',
  FEED_ITEM_DELETED = '[Feed] Feed Item Deleted',
}

export enum FeedLastSeenUpdatedTypes {
  FEED_LAST_SEEN_UPDATED = '[Feed] Feed Last Seen Updated',
}

/**
 * Payloads
 */
export interface FeedTypingListUpdatedPayload {
  userId: string;
  feedId: number;
  typing: string[];
}

export interface FeedItemUpdatedEventPayload {
  userId: string;
  feedItemModelView: FeedItemsViewDto;
}
export interface FeedItemDeletedEventPayload {
  userId: string;
  feedItemId: number;
}
export interface FeedLastSeenUpdatedEventPayload {
  feed: FeedDto;
}

/**
 * Feed Item Events
 */
export class FeedItemUpdatedEvent {
  readonly type = FeedItemUpdatedTypes.FEED_ITEM_UPDATED;

  constructor(public payload: FeedItemUpdatedEventPayload) {}
}

export class FeedItemDeletedEvent {
  readonly type = FeedItemUpdatedTypes.FEED_ITEM_DELETED;

  constructor(public payload: FeedItemDeletedEventPayload) {}
}

export class FeedLastSeenUpdatedEvent {
  readonly type = FeedLastSeenUpdatedTypes.FEED_LAST_SEEN_UPDATED;

  constructor(public payload: FeedLastSeenUpdatedEventPayload) {}
}
